exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(/main.style.css);", ""]);

// module
exports.push([module.id, "\n", ""]);

// exports
